import { render } from "./Info.vue?vue&type=template&id=00741e63&scoped=true&ts=true&lang=pug"
import script from "./Info.vue?vue&type=script&lang=ts"
export * from "./Info.vue?vue&type=script&lang=ts"

import "./Info.vue?vue&type=style&index=0&id=00741e63&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00741e63"]])

export default __exports__